<template>
  <BasicLayout>
    <template #wrapper>
      <UserOpenPush />
      <el-card class="box-card" style="margin-top: 10px;">
        <div slot="header" class="clearfix">
          <span>推送配置</span>
          <CommonExport :import-p="'config:pushConfig:import'" :export-p="'config:pushConfig:export'" :get-table="getTables" :import-method="importPushCfg" :export-method="exportPushCfg" />
          <el-button v-permisaction="['config:pushConfig:add']" type="primary" size="mini" style="margin-left: 16px;" @click="edit(formDataBak)">新增</el-button>
          <clear-cache-apply />
          <sync-data />
        </div>

        <template>
          <el-table
            :data="tableData"
            border
            style="width: 100%"
          >
            <el-table-column
              prop="id"
              label="ID"
              align="center"
            />
            <el-table-column
              prop="name"
              label="名称"
              align="center"
            />
            <el-table-column
              prop="class"
              label="类型"
              align="center"
              :formatter="classFormatter"
            />
            <el-table-column
              prop="type"
              label="子类型"
              align="center"
              :formatter="typeFormatter"
            />
            <el-table-column
              prop="status"
              label="状态"
              align="center"
              :formatter="statusFormatter"
            />
            <el-table-column
              fixed="right"
              label="操作"
              width="200"
            >
              <template v-slot:default="scope">
                <el-button v-permisaction="['config:pushConfig:edit']" type="text" size="small" @click="edit(scope.row)">编辑</el-button>
                <el-button v-permisaction="['config:pushConfig:del']" type="text" size="small" @click="del(scope.row.id)">删除</el-button>
                <el-button v-if="pushMsgType.includes(scope.row.type)" v-permisaction="['config:pushConfig:push']" type="text" size="small" @click="push(scope.row.type)">推送</el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            v-show="total>0"
            background
            :page.sync="queryParams.pageIndex"
            :limit.sync="queryParams.pageSize"
            :total="total"
            @pagination="getTables"
          />
        </template>
      </el-card>

      <el-drawer
        title="配置"
        :visible.sync="drawer"
        size="1100px"
        :before-close="handleClose"
      >
        <el-form ref="formData" :rules="rules" :model="formData" label-width="100px">
          <el-form-item label="状态" prop="status">
            <el-select v-model.number="formData.status" placeholder="请选择">
              <el-option
                v-for="item in statusType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="名称" prop="name" style="width: 400px;">
            <el-input v-model.number="formData.name" placeholder="名称" />
          </el-form-item>
          <el-form-item label="类型" prop="class">
            <el-select v-model.number="formData.class" placeholder="请选择">
              <el-option
                v-for="item in classType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="子类型" prop="type">
            <el-select v-model.number="formData.type" placeholder="请选择" @change="listenPushType">
              <el-option
                v-for="item in pushType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="图片" prop="img">
            <el-upload
              class="avatar-uploader"
              :action="sys_app_logoAction"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :on-error="handleAvatarError"
              :before-upload="beforeAvatarUpload"
              :headers="headers"
            >
              <img v-if="dialogImageUrl" :src="dialogImageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon" />
              <i v-if="dialogImageUrl" class="el-icon-plus el-icon-delete avatar-uploader-icon2" @click.stop="delImg" />
            </el-upload>

          </el-form-item>
          <el-form-item label="中文">
            <el-form :inline="true" label-width="50px">
              <el-form-item label="标题" prop="title" style="width: 300px">
                <el-input v-model="formData.conf.zh.title" placeholder="标题" />
              </el-form-item>
              <el-form-item label="内容" prop="content">
                <el-input v-model="formData.conf.zh.content" style="width: 500px" placeholder="内容" />
              </el-form-item>
            </el-form>
          </el-form-item>

          <el-form-item label="英语">
            <el-form :inline="true" label-width="50px">
              <el-form-item label="标题" prop="title" style="width: 300px">
                <el-input v-model="formData.conf.en.title" placeholder="标题" />
              </el-form-item>
              <el-form-item label="内容" prop="content">
                <el-input v-model="formData.conf.en.content" style="width: 500px" placeholder="内容" />
              </el-form-item>
            </el-form>
          </el-form-item>

          <el-form-item label="德国">
            <el-form :inline="true" label-width="50px">
              <el-form-item label="标题" prop="title" style="width: 300px">
                <el-input v-model="formData.conf.de.title" placeholder="标题" />
              </el-form-item>
              <el-form-item label="内容" prop="content">
                <el-input v-model="formData.conf.de.content" style="width: 500px" placeholder="内容" />
              </el-form-item>
            </el-form>
          </el-form-item>

          <el-form-item label="西班牙">
            <el-form :inline="true" label-width="50px">
              <el-form-item label="标题" prop="title" style="width: 300px">
                <el-input v-model="formData.conf.es.title" placeholder="标题" />
              </el-form-item>
              <el-form-item label="内容" prop="content">
                <el-input v-model="formData.conf.es.content" style="width: 500px" placeholder="内容" />
              </el-form-item>
            </el-form>
          </el-form-item>

          <el-form-item label="法 语">
            <el-form :inline="true" label-width="50px">
              <el-form-item label="标题" prop="title" style="width: 300px">
                <el-input v-model="formData.conf.fr.title" placeholder="标题" />
              </el-form-item>
              <el-form-item label="内容" prop="content">
                <el-input v-model="formData.conf.fr.content" style="width: 500px" placeholder="内容" />
              </el-form-item>
            </el-form>
          </el-form-item>

          <el-form-item label="印 尼">
            <el-form :inline="true" label-width="50px">
              <el-form-item label="标题" prop="title" style="width: 300px">
                <el-input v-model="formData.conf.id.title" placeholder="标题" />
              </el-form-item>
              <el-form-item label="内容" prop="content">
                <el-input v-model="formData.conf.id.content" style="width: 500px" placeholder="内容" />
              </el-form-item>
            </el-form>
          </el-form-item>

          <el-form-item label="挪 威">
            <el-form :inline="true" label-width="50px">
              <el-form-item label="标题" prop="title" style="width: 300px">
                <el-input v-model="formData.conf.no.title" placeholder="标题" />
              </el-form-item>
              <el-form-item label="内容" prop="content">
                <el-input v-model="formData.conf.no.content" style="width: 500px" placeholder="内容" />
              </el-form-item>
            </el-form>
          </el-form-item>

          <el-form-item label="葡萄牙">
            <el-form :inline="true" label-width="50px">
              <el-form-item label="标题" prop="title" style="width: 300px">
                <el-input v-model="formData.conf.pt.title" placeholder="标题" />
              </el-form-item>
              <el-form-item label="内容" prop="content">
                <el-input v-model="formData.conf.pt.content" style="width: 500px" placeholder="内容" />
              </el-form-item>
            </el-form>
          </el-form-item>

          <el-form-item label="泰 语">
            <el-form :inline="true" label-width="50px">
              <el-form-item label="标题" prop="title" style="width: 300px">
                <el-input v-model="formData.conf.th.title" placeholder="标题" />
              </el-form-item>
              <el-form-item label="内容" prop="content">
                <el-input v-model="formData.conf.th.content" style="width: 500px" placeholder="内容" />
              </el-form-item>
            </el-form>
          </el-form-item>

          <el-form-item label="繁 体">
            <el-form :inline="true" label-width="50px">
              <el-form-item label="标题" prop="title" style="width: 300px">
                <el-input v-model="formData.conf.tw.title" placeholder="标题" />
              </el-form-item>
              <el-form-item label="内容" prop="content">
                <el-input v-model="formData.conf.tw.content" style="width: 500px" placeholder="内容" />
              </el-form-item>
            </el-form>
          </el-form-item>

          <el-form-item label="越 南">
            <el-form :inline="true" label-width="50px">
              <el-form-item label="标题" prop="title" style="width: 300px">
                <el-input v-model="formData.conf.vn.title" placeholder="标题" />
              </el-form-item>
              <el-form-item label="内容" prop="content">
                <el-input v-model="formData.conf.vn.content" style="width: 500px" placeholder="内容" />
              </el-form-item>
            </el-form>
          </el-form-item>

          <el-form-item style="width:100%;margin-top:50px;text-align: center">
            <el-button type="primary" @click="onSubmit()">保存</el-button>
          </el-form-item>
        </el-form>
      </el-drawer>

    </template>
  </BasicLayout>
</template>

<script>
import {
  delPush,
  exportPushCfg,
  getPushClassType,
  getPushList,
  getPushType,
  importPushCfg, PushMsg,
  updatePushCfg
} from '@/api/config/push-cfg'
import CommonExport from '@/components/CommonExport/index.vue'
import UserOpenPush from '@/views/config/push-config/components/push-reward.vue'
import { getToken } from '@/utils/auth'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'

export default {
  name: 'PushConfig',
  components: { SyncData, ClearCacheApply, CommonExport, UserOpenPush },
  data() {
    return {
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      total: 0,
      rewardTypes: [],
      tableData: [],
      loading: false,
      drawer: false,
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      pushMsgType: ['version_update', 'update_card_group', '关卡更新'],
      lang: {
        'en': '英 文',
        'zh': '中 文',
        'tw': '繁 体',
        'fr': '法 语',
        'de': '德 语',
        'es': '西班牙',
        'pt': '葡萄牙',
        'th': '泰 语',
        'vn': '越 南',
        'no': '挪 威',
        'id': '印 尼'
      },
      statusType: [{ label: '禁用', value: 0 }, { label: '启用', value: 1 }],
      formDataBak: {
        id: '',
        name: '',
        class: 'activityOnline',
        type: 'balloon',
        status: 0,
        conf: {
          zh: { title: '', content: '' },
          de: { title: '', content: '' },
          en: { title: '', content: '' },
          es: { title: '', content: '' },
          fr: { title: '', content: '' },
          id: { title: '', content: '' },
          no: { title: '', content: '' },
          pt: { title: '', content: '' },
          tw: { title: '', content: '' },
          vn: { title: '', content: '' },
          th: { title: '', content: '' }
        },
        img: ''
      },
      formData: {
        id: '',
        name: '',
        class: 'activityOnline',
        type: 'balloon',
        status: 0,
        img: '',
        conf: {
          zh: { title: '', content: '' },
          de: { title: '', content: '' },
          en: { title: '', content: '' },
          es: { title: '', content: '' },
          fr: { title: '', content: '' },
          id: { title: '', content: '' },
          no: { title: '', content: '' },
          pt: { title: '', content: '' },
          tw: { title: '', content: '' },
          vn: { title: '', content: '' },
          th: { title: '', content: '' }
        }
      },
      dialogImageUrl: '',
      classType: [],
      pushType: [],
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getaPushClassType()
    this.getTables()
  },
  methods: {
    exportPushCfg,
    importPushCfg,
    handleClose(d) {
      this.drawer = false
    },
    getaPushClassType() {
      getPushClassType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            const val = res.data[i]
            this.classType.push({ label: val, value: i })
          }
        }
      })

      getPushType().then(res => {
        for (const i in res.data) {
          const val = res.data[i]
          this.pushType.push({ label: val, value: i, disabled: false })
        }
      })
    },
    listenPushType() {
      this.pushType.forEach((item, index) => {
        this.pushType[index].disabled = false
      })

      this.tableData.forEach((item, index) => {
        for (const i in this.pushType) {
          const val = this.pushType[i]
          if (val.value === item.type) {
            this.pushType[i].disabled = true
            break
          }
        }
      })
    },
    edit(row) {
      this.formData = row
      this.dialogImageUrl = this.formData.img
      this.listenPushType()
      for (const lang in this.lang) {
        // eslint-disable-next-line no-prototype-builtins
        if (!this.formData.conf.hasOwnProperty(lang)) {
          this.$set(this.formData.conf, lang, { title: '', content: '' })
        }
      }
      if (this.formData.id === '') {
        let selectType = ''
        for (const i in this.pushType) {
          const val = this.pushType[i]
          if (!val.disabled) {
            selectType = val.value
            break
          }
        }

        if (!selectType) {
          this.msgError('无可选类型')
          return
        }

        this.formData.type = selectType
      }
      this.drawer = true
    },
    del(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delPush({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    push(type) {
      this.$confirm('此操作将向所有人推送数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        PushMsg({ type: type }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    onSubmit() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          const _data = this.formData
          for (const i in _data.conf) {
            const val = _data.conf[i]
            if (val.title === '') {
              this.msgError('请输入标题')
              return
            }

            if (val.content === '') {
              this.msgError('请输入内容')
              return
            }
          }

          const data = JSON.stringify(this.formData)
          updatePushCfg({ data: data }).then(res => {
            if (res.code === 200) {
              this.drawer = false
              this.formData = this.formDataBak
              this.msgSuccess(res.msg)
              this.getTables()
            } else {
              this.msgError(res.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getTables() {
      this.loading = true
      getPushList(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data
          // this.total = res.data.count
          this.listenPushType()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.drawer = true
    },
    statusFormatter(row, col) {
      let statusText = ''
      for (const i in this.statusType) {
        const val = this.statusType[i]
        if (val.value === row.status) {
          statusText = val.label
          break
        }
      }
      return statusText
    },
    classFormatter(row, col) {
      let classTypeText = ''
      for (const i in this.classType) {
        const val = this.classType[i]
        if (val.value === row.class) {
          classTypeText = val.label
          break
        }
      }
      return classTypeText
    },
    typeFormatter(row, col) {
      let typeText = ''
      for (const i in this.pushType) {
        const val = this.pushType[i]
        if (val.value === row.type) {
          typeText = val.label
          break
        }
      }
      return typeText
    },
    userLimitFormatter(row, col) {
      let text = ''
      row.userLimit.forEach(item => {
        text += item + ','
      })

      return text
    },
    handleAvatarSuccess(res, file) {
      const currentDomain = process.env.VUE_APP_BASE_API
      this.dialogImageUrl = currentDomain + res.data.path
      this.formData.img = res.data.path
    },
    handleAvatarError(err, file, fileLis) {
      console.log(err)
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPng = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 10

      if (!isJPG && !isPng) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 10MB!')
        return false
      }
      return true
    },
    delImg() {
      this.formData.img = ''
      this.dialogImageUrl = ''
    }
  }
}
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar-uploader-icon2 {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
